const desigual = {
  createTitle: "Add Supplier",
  editTitle: "Edit Supplier",
  exportAllSuppliers: "Export all suppliers",
  exportAllSuppliersConfirmation:
    "Are you sure you want to export all suppliers to a CSV file?",
  exportCsvFailed: "Failed to export CSV",
  savedMessage: "Supplier saved successfully",
  createdMessage: "Supplier created successfully",
  updatedMessage: "Supplier updated successfully",
  stepRequester: "Requester",
  stepSupplierData: "Supplier Data",
  stepAddress: "Address",
  stepContacts: "Contacts",
  stepBanking: "Banking",
  stepCurrency: "Currency",
  stepPaymentTerms: "Payment Terms",
  stepPaymentMethod: "Payment Method",
  stepBilling: "Billing",
  stepDocuments: "Documents",
  viewDocCodeOfEthics: "Code of Ethics",
  viewDocTermsAndConditions:
    "General Terms and Conditions of Contracting with Desigual",
  viewDocDataProcessingAgreement: "Personal Data Processing Agreement",
  viewDocument: "View Document",
  requesterName: "Requester Name",
  requesterEmail: "Requester Email",
  supplierEmail: "Contact Email (Supplier)",
  dossierApprover: "AP Approver",
  businessApprover: "Business Approver",
  activationDate: "Activation Date",
  companyIds: "Company IDs",
  category: "Category",
  supplierName: "Supplier Name",
  vatNif: "VAT / NIF",
  entityType: "Individual / Legal Entity",
  withholdingTax: "Withholding Tax",
  withholdingTaxRate: "Withholding Tax Rate (%)",
  street: "Street",
  streetNumber: "Street Number",
  city: "City",
  regionProvince: "Region / Province",
  postalCode: "Postal Code",
  country: "Country",
  contact: "Contact",
  addContact: "Add Contact",
  fullName: "Full Name",
  language: "Language",
  phone: "Phone",
  orderEmail: "Order Email",
  bankName: "Bank Name",
  bankCode: "Bank Code",
  accountNumber: "Account Number",
  checkDigit: "Check Digit",
  iban: "IBAN",
  swiftBic: "SWIFT / BIC",
  intermediaryBank: "Intermediary Bank",
  intermediaryBic: "Intermediary BIC",
  currency: "Currency",
  paymentTerm: "Payment Term",
  paymentTermOther: "Other Payment Term Specification",
  paymentMethod: "Payment Method",
  instructionKey: "Billing Instruction Key",
  accountGroup: "Billing Account Group",
  purchasingOrganisation: "Purchasing Organisation",
  purchasingGroup: "Purchasing Group",
  internalSupplierId: "Internal Supplier ID",
  treasuryGroup: "Treasury Group",
  bankCertificate: "Bank Certificate",
  bankCertDate: "Bank Certificate Issue Date",
  bankCertExpiry: "Bank Certificate Expiry Date",
  taxCertificate: "Tax Residence Certificate",
  taxCertIssue: "Tax Certificate Issue Date",
  taxCertExpiry: "Tax Certificate Expiry Date",
  contractWithDesigual: "Contract with Desigual",
  tcApproval: "I accept the Terms & Conditions",
  tcQuestion: "Do you accept the General Terms and Conditions?",
  tcHelper:
    'If you select "No", upload your signed contract with Desigual as justification.',
  optional: "optional",
  yes: "Yes",
  no: "No",
  individual: "Individual",
  legal: "Legal Entity",
  general: "General Purchasing",
  product: "Product",
  freight: "Freight Forwarders",
  "30d": "30 Days",
  "60d": "60 Days",
  "90d": "90 Days",
  other: "Other",
  directDebit: "Direct Debit",
  letterOfCredit: "Letter of Credit",
  confirming: "Confirming",
  transfer: "Transfer",
  common: {
    cancel: "Cancel",
    save: "Save",
    saveWithoutReset: "Save without reset status",
    submit: "Submit",
    update: "Update",
    back: "Back",
    next: "Next",
  },
  validation: {
    requesterName: { required: "Requester Name is required" },
    requesterEmail: {
      required: "Requester Email is required",
      invalid: "Invalid email address",
    },
    supplierEmail: {
      required: "Supplier Email is required",
      invalid: "Invalid email address",
    },
    dossierApproverEmail: { required: "Dossier Approver is required" },
    businessApproverEmail: { required: "Business Approver is required" },
    companyIds: { required: "At least one Company ID is required" },
    category: { required: "Category is required" },
    purchasingOrganisation: { required: "Purchasing Organisation is required" },
    withholdingTaxRate: { range: "Must be between 0 and 100" },
    orderEmail: { invalid: "Invalid email address" },
    taxCertExpiryDate: {
      afterIssue: "Expiry date must be after issue date",
      required: "Tax Certificate Expiry Date is required",
    },
    contractWithDesigual: {
      required: "Please upload your signed contract with Desigual",
    },
    supplierName: { required: "Supplier Name is required" },
    registrationNumber: { required: "Registration Number is required" },
    entityType: { required: "Individual / Legal Entity is required" },
    street: { required: "Street is required" },
    streetNumber: { required: "Street Number is required" },
    city: { required: "City is required" },
    regionProvince: { required: "Region / Province is required" },
    postalCode: { required: "Postal Code is required" },
    country: { required: "Country is required" },
    contactFullName: { required: "Full Name is required" },
    contactLanguage: { required: "Language is required" },
    contactNumber: {
      required: "Phone is required",
      invalid: "Phone must contain digits only",
      maxLength: "Phone must be at most 15 digits",
    },
    contactOrderEmail: { required: "Order Email is required" },
    bankName: { required: "Bank Name is required" },
    bankCode: { required: "Bank Code is required" },
    bankAccountNumber: { required: "Account Number is required" },
    bankCheckDigit: { required: "Check Digit is required" },
    iban: { required: "IBAN is required" },
    bic: { required: "SWIFT / BIC is required" },
    intermediaryBank: { required: "Intermediary Bank is required" },
    currency: { required: "Currency is required" },
    paymentTerm: { required: "Payment Term is required" },
    paymentTermDescription: {
      required: "Other Payment Term Specification is required",
    },
    paymentMethod: { required: "Payment Method is required" },
    billingInstructionKey: { required: "Billing Instruction Key is required" },
    billingAccountGroup: { required: "Billing Account Group is required" },
    purchasingGroup: { required: "Purchasing Group is required" },
    internalSupplierId: { required: "Internal Supplier ID is required" },
    treasuryGroup: { required: "Treasury Group is required" },
    bankCertificate: { required: "Bank Certificate is required" },
    bankCertIssueDate: { required: "Bank Certificate Issue Date is required" },
    bankCertExpiryDate: {
      required: "Bank Certificate Expiry Date is required",
    },
    taxResidenceCertificate: {
      required: "Tax Residence Certificate is required",
    },
    taxCertIssueDate: { required: "Tax Certificate Issue Date is required" },
  },
};

export default desigual;
